import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  @Input() value: number = 0;
  @Input() max: number = 100;
  @Input() label: string = '';

  get percent(): number {
    if (!this.max || this.max === 0) return 0;
    return Math.min(100, Math.round((this.value / this.max) * 100));
  }
}
